<template>
  <v-select v-bind="$attrs" hide-details outlined :value="value" @input="$emit('input', $event)">
    <slot/>
  </v-select>
</template>

<script>
export default {
  name: "XSelect",
  props: ['value']
}
</script>

<style scoped lang="css">
.v-select >>> .v-input__slot {
  border-radius: 8px !important;
}

.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-select.v-select--enclosed .v-select__details {
  margin-bottom: 0;
}

.v-input--dense.v-text-field--outlined .v-input__slot,
.v-input--dense.v-select--outlined .v-input__slot {
  /* min-height: 40px; */
}
</style>
